import React from "react";
import { Box, Checkbox } from "@mui/material";

import { ReactComponent as CheckDefIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckClearIcon } from "assets/images/icons/checkbox_clear.svg";
import { ReactComponent as CheckFillIcon } from "assets/images/icons/checkbox_fiilled.svg";

export const IndeterminateCheckbox = ({ indeterminate = false, header, disabled, ...rest }) => (
  <Checkbox
    icon={<CheckDefIcon style={{ width: 44, height: 25 }} />}
    checkedIcon={<CheckFillIcon style={{ width: 44, height: 25 }} />}
    indeterminateIcon={header ? <CheckClearIcon style={{ width: 44, height: 25 }} /> : undefined}
    indeterminate={header ? indeterminate : false}
    disabled={disabled}
    {...rest}
  />
);

const CheckboxColumn = (columnHelper, header, options = {}) => {
  const {
    getRowDisabled,
    disableByColumnData,
    enableColumnPinning = true
  } = options;

  return columnHelper.display({
    id: "select",
    meta: { align: "center" },
    enableColumnPinning,
    header: header
      ? header
      : ({ table }) => {
        const allRows = table.getCoreRowModel().rows;
        const selectableRows = getRowDisabled
          ? allRows.filter((item) => !getRowDisabled(item.original, table))
          : disableByColumnData?.length > 0
            ? allRows.filter((item) => !disableByColumnData.some(({ key, value }) => item.original?.[key] === value))
            : allRows;

        const allSelected = selectableRows.length > 0 && selectableRows.every((item) => item.getIsSelected?.());
        const someSelected = selectableRows.some((item) => item.getIsSelected?.());

        const headerDisabled = !!getRowDisabled
          ? !allRows.some(
            (item) => item.getIsSelected?.() || item.getIsSomeSelected?.()
          )
          : false;

        return (
          <>
            {
              header === "" && headerDisabled
                ? ""
                : <IndeterminateCheckbox
                  header
                  checked={allSelected}
                  indeterminate={!allSelected && someSelected}
                  disabled={headerDisabled}
                  onChange={() => {
                    const shouldSelectAll = !allSelected;
                    selectableRows.forEach((item) =>
                      item.toggleSelected?.(shouldSelectAll)
                    );
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
            }

          </>
        );
      },
    cell: ({ row, table }) => {
      const isDisabled = disableByColumnData?.length
        ? disableByColumnData.some(({ key, value }) => {
          return row.original?.[key] === value;
        })
        : (getRowDisabled ? getRowDisabled(row.original, table) : false);

      const isChecked = isDisabled ? false : row.getIsSelected?.() ?? false;

      return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <IndeterminateCheckbox
            checked={isChecked}
            indeterminate={false}
            disabled={isDisabled}
            onChange={row.getToggleSelectedHandler?.()}
            onClick={(e) => e.stopPropagation()}
          />
        </Box>
      );
    },

  });
};

export default CheckboxColumn;
